// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0249ed48","455":"eb933dc1","977":"d71a43e2"}[chunkId] + ".chunk.js";
};